/**
 * Cage-related constants
 */

/**
 * Maximum number of animals allowed per cage
 */
export const MAX_CAGE_POPULATION = 15;
